import { MyqqRouteState } from "./router.models";
import { Lens } from "src/app/shared/utilities/state/Optics";

const routerProps = Lens.fromProp<MyqqRouteState>();
export const routerStateLens = routerProps("state");
